import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useT } from '~app/core/BundleProvider';
import { actions as CanvasActions } from '~app/features/canvas';
import withEnterToClick from '~app/core/withEnterToClick';

const ClickOrEnterDiv = withEnterToClick('div');

const ZoomToolUI = () => {
  const t = useT();
  const scale = useSelector(state => state.canvas.scale);
  // TODO: hide or disable these controls if there's no document yet
  //const isVisible = !!useSelector(state => state.document.present);
  const dispatch = useDispatch();

  const zoomIn = React.useCallback(() => {
    dispatch(CanvasActions.zoomIn());
  }, [dispatch]);

  const zoomOut = React.useCallback(() => {
    dispatch(CanvasActions.zoomOut());
  }, [dispatch]);

  // TODO: use these to set the zoom buttons to disabled state
  //const canZoomIn = useSelector(state => state.canvas.canZoomIn);
  //const canZoomOut = useSelecotr(state => state.canvas.canZoomOut);

  return (
    <div className="ZoomTool__container">
      <ClickOrEnterDiv
        className="ZoomTool__button ZoomTool__button--right"
        role="button"
        tabIndex="0"
        aria-label={t('zoom-out')}
        onClick={zoomOut}
      >
        &minus;
      </ClickOrEnterDiv>
      <div className="ZoomTool__PctReadout">{Math.round(scale * 100)}%</div>
      <ClickOrEnterDiv
        className="ZoomTool__button ZoomTool__button--left"
        role="button"
        tabIndex="0"
        aria-label={t('zoom-in')}
        onClick={zoomIn}
      >
        +
      </ClickOrEnterDiv>
    </div>
  );
};

export default ZoomToolUI;
